import React from 'react';
import IconButton from 'components/generics/IconButton';
import Edit from 'components/pages/Home/Edit';
// import Delete from 'components/icons/Delete';

const QuoteStatusTable  = props => (
    <table>
      <thead>
        <tr>
          <th>Nom</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {props.quoteStatus.length > 0 ? (
          props.quoteStatus.map(item => (
            <tr key={item.id}>
              <td>{item.name}</td>
              <td>{item.description}</td>
              <td className="actionner">
                <IconButton onClick={() => props.editRow(item)} icon={<Edit  />} />
                {/* <IconButton  onClick={() => props.handleDeleteQuoteStatus(item.id)} icon={<Delete  />} /> */}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={3}>Pas de statut pour les devis</td>
          </tr>
        )}
      </tbody>
    </table>
  )
  

export default QuoteStatusTable;
